import { ReactNode } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface ProtectedRouteProps {
  children: ReactNode
  requireAdmin?: boolean
}

export default function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading: auth0Loading, loginWithRedirect } = useAuth0()
  const { isAdmin, isLoading: authLoading } = useAuth()
  const location = useLocation()

  if (auth0Loading || authLoading) {
    return null
  }

  if (!isAuthenticated) {
    loginWithRedirect({ appState: { returnTo: location.pathname } })
    return null
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <h1 className="mt-4 text-2xl font-bold text-gray-900 dark:text-white">Access Denied</h1>
          <p className="mt-2 text-gray-600 dark:text-gray-300">
            You need administrator privileges to access this page.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>
}


